module.exports = __webpack_public_path__ + "static/averta-bold-2e3b4b1bf2944d4bc244988633fde9e4.woff2";